export default __webpack_public_path__ + "static/object-tile-size-light-cc8a1ebcb68338b6a4f8832de277de36.png";